const pageList = [
    { 
        code: "sysAdmin", 
        url: "/Admin/List", 
        name: "管理员信息",
        handle: {
            insert: true,
            update: true,
            delete: true,
            export: true,
            detail: true
        },
        table: [
            { label: "管理员名称", prop: "sysAdminName", type: "text", fixed: "" },
            { label: "角色名称", prop: "sysRoleName", type: "text" },
            { label: "管理员状态", prop: "sysAdminStatus", type: "enum", enum: "status", width: 120 },
            { label: "创建时间", prop: "createTime", type: "date" },
        ],
        form: [
            { label: "管理员名称", prop: "sysAdminName", type: "text" },
            { label: "角色名称", prop: "sysRoleId", type: "reference", reference: "sysRole", referenceLabel: "sysRoleName", referenceValue: "sysRoleId" },
            { label: "管理员密码", prop: "sysAdminPassword", type: "password" },
            { label: "管理员状态", prop: "sysAdminStatus", type: "enum", enum: "status" },
        ],
        filter: [
            { label: "管理员名称", prop: "sys_admin_name", type: "text" },
            { label: "角色名称", prop: "sys_role_name", type: "text" }
        ]
    },
    { code: "sysRole", url: "/Role/List", name: "角色信息" },
    { code: "sysPermission", url: "/Permission/List", name: "权限信息" },
    { code: "inventoryCategory", url: "/Category/List", name: "品类信息" },
    { code: "inventoryCustomer", url: "/Customer/List", name: "客户信息" },
    { 
        code: "inventoryPayment", 
        url: "/Payment/List", 
        name: "结算单信息",
        handle: {
            insert: true,
            update: true,
            delete: true,
            export: true,
            detail: true
        },
        filter: [
            { label: "公司名称", prop: "inventory_customer_name", type: "text" },
            { label: "产品名称", prop: "inventory_category_name", type: "text" },
            { label: "负责人", prop: "inventory_customer_person", type: "text" }
        ],
        exportMap: [
            //COMMON
            { name: "月份", value: "inventoryCommonMonth", checked: true }, 
            { name: "公司名称", value: "inventoryCustomerName", checked: true }, 
            { name: "负责人", value: "inventoryCustomerPerson", checked: true }, 
            { name: "项目", value: "inventoryCategoryName", checked: true }, 
            //上游计划
            { name: "计划贸易量", value: "inventoryAccountPlanTradeAmount", checked: true }, 
            { name: "上游费率", value: "inventoryCategoryPercentUp", checked: true }, 
            { name: "上游计划费用", value: "inventoryAccountPlanTradeFee", checked: true }, 
            { name: "上游计划过夜比例", value: "inventoryAccountPlanNightPercent", checked: true }, 
            { name: "上游计划过夜费率", value: "inventoryAccountPlanNightRate", checked: true }, 
            { name: "上游计划过夜费", value: "inventoryAccountPlanNightFee", checked: true }, 
            { name: "计划利差比例", value: "inventoryAccountPlanProfitRate", checked: true }, 
            { name: "上游计划利差金额", value: "inventoryAccountPlanProfitFee", checked: true }, 
            { name: "上游计划备注", value: "inventoryAccountPlanMemo", checked: true }, 
            { name: "上游计划服务费", value: "inventoryAccountPlanServiceTotal", checked: true }, 
            { name: "上游计划合计", value: "inventoryAccountPlanFeeTotal", checked: true }, 
            //上游实际
            { name: "实际开票金额", value: "inventoryAccountActualTradeAmount", checked: true }, 
            { name: "上游费率", value: "inventoryCategoryPercentUp", checked: true }, 
            { name: "上游实际贸易服务费", value: "inventoryAccountActualServiceFee", checked: true }, 
            { name: "上游实际利差费率", value: "inventoryAccountPlanProfitRate", checked: true }, 
            { name: "上游实际利差", value: "inventoryAccountActualProfit", checked: true }, 
            { name: "上游实际过夜金额", value: "inventoryAccountActualNightAmount", checked: true }, 
            { name: "上游实际过夜费率", value: "inventoryAccountPlanNightRate", checked: true },
            { name: "上游实际过夜费", value: "inventoryAccountActualNightFee", checked: true }, 
            { name: "上游实际备注", value: "inventoryAccountActualMemo", checked: true }, 
            { name: "上游实际合计", value: "inventoryAccountActualTotal", checked: true }, 
            { name: "上游实际预付", value: "inventoryAccountActualPay", checked: true }, 
            { name: "上游实际剩余", value: "inventoryAccountActualUnpay", checked: true }, 
            //下游计划
            { name: "计划贸易量", value: "inventoryAccountPlanTradeAmount", checked: true }, 
            { name: "下游费率", value: "inventoryCategoryPercentDown", checked: true }, 
            { name: "下游计划贸易费用", value: "inventoryPaymentPlanTradeFee", checked: true }, 
            { name: "下游计划过夜比例", value: "inventoryAccountPlanNightPercent", checked: true }, 
            { name: "下游计划过夜费率", value: "inventoryPaymentPlanNightRate", checked: true }, 
            { name: "下游计划过夜费", value: "inventoryPaymentPlanNightFee", checked: true }, 
            { name: "计划利差比例", value: "inventoryAccountPlanProfitRate", checked: true }, 
            { name: "下游计划利差", value: "inventoryPaymentPlanProfitFee", checked: true }, 
            { name: "下游财务费", value: "inventoryPaymentPlanFeeFinance", checked: true }, 
            { name: "下游计划服务费", value: "inventoryPaymentPlanFeeService", checked: true }, 
            { name: "下游计划总计", value: "inventoryPaymentPlanFeeTotal", checked: true }, 
            //下游实际
            { name: "实际开票金额", value: "inventoryAccountActualTradeAmount", checked: true }, 
            { name: "下游实际服务费", value: "inventoryPaymentActualTradeService", checked: true }, 
            { name: "下游实际利差费率", value: "inventoryAccountPlanProfitRate", checked: true }, 
            { name: "下游实际利差", value: "inventoryPaymentActualProfitFee", checked: true }, 
            { name: "下游实际过夜金额", value: "inventoryPaymentActualNightAmount", checked: true }, 
            { name: "下游实际过夜费", value: "inventoryPaymentActualNightFee", checked: true }, 
            { name: "下游财务费", value: "inventoryPaymentPlanFeeFinance", checked: true }, 
            { name: "服务费", value: "inventoryPaymentActualServiceTotal", checked: true }, 
            { name: "下游实际总费用", value: "inventoryPaymentActualFeeTotal", checked: true }, 
            { name: "下游实际预付", value: "inventoryPaymentActualPay", checked: true }, 
            { name: "下游实际剩余", value: "inventoryPaymentActualUnpay", checked: true }, 
            //合计
            { name: "上游计划合计", value: "inventoryAccountPlanFeeTotal", checked: true }, 
            { name: "下游计划合计", value: "inventoryPaymentPlanFeeTotal", checked: true }, 
            { name: "计划利润", value: "inventoryCommonPlanProfit", checked: true }, 
            { name: "上游实际合计", value: "inventoryAccountActualTotal", checked: true }, 
            { name: "下游实际合计", value: "inventoryPaymentActualFeeTotal", checked: true }, 
            { name: "实际利润", value: "inventoryCommonActualProfit", checked: true }, 
            { name: "上游结算", value: "inventoryAccountActualStatus", checked: true }, 
            { name: "下游结算", value: "inventoryPaymentActualStatus", checked: true }
        ]
    },
]

//code可以是URL或编码，先尝试URL后尝试Code
export function getPageMap(code) {
    if (pageList.some(p => p.url === code)) return pageList.find(p => p.url === code)
    else if (pageList.some(p => p.code === code)) return pageList.find(p => p.code === code)
    throw new Error(`未找到页面配置：${code}`)
}